import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=5a217d86&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=5a217d86&prod&lang=scss"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=5a217d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a217d86",
  null
  
)

export default component.exports